import {
    getCurrentYear,
    toLocalDate,
} from '../utils';

export const holidaysYearValidator = (t, holidayYears) => (input) => {
    let err = null;
    if (!input) {
        err = t('holidays.validation.year-empty');
    } else if (!(input instanceof Date)) {
        err = t('holidays.validation.year-not-a-date');
    } else if (holidayYears.some((holidayYear) => holidayYear.year === input.getFullYear())) {
        err = t('holidays.validation.year-already-in-use');
    } else if (input.getFullYear() < getCurrentYear()) {
        err = t('holidays.validation.year-in-past');
    }
    return err;
};

export const HOLIDAYS_NAME_MAX_LENGTH = 128;
export const holidaysNameValidator = (t) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('holidays.validation.name-empty');
    } else if (input.trim().length > HOLIDAYS_NAME_MAX_LENGTH) {
        err = t('holidays.validation.name-too-long', { maxLetters: HOLIDAYS_NAME_MAX_LENGTH });
    }
    return err;
};

export const holidaysDateValidator = (t, holidays, currentHolidayId) => (input) => {
    let err = null;
    if (!input) {
        err = t('holidays.validation.date-empty');
    } else if (!(input instanceof Date)) {
        err = t('holidays.validation.date-not-a-date');
    } else if (
        holidays
            .filter((holiday) => holiday.id !== currentHolidayId)
            .some((holiday) => holiday.dateWithoutYear === toLocalDate(input).substring(5))
    ) {
        err = t('holidays.validation.date-already-in-use');
    }
    return err;
};

export const holidaysItemsValidator = (t) => (input) => {
    let err = null;
    if (!input?.length) {
        err = t('holidays.validation.holidays-empty');
    }
    return err;
};
